import { z } from 'zod'

export const savedDeviceSearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50)]).catch(50),
  sortBy: z.enum(['created', 'lastUsed']).catch('created'),
  direction: z.enum(['asc', 'desc']).catch('desc'),
})
